
const HelpText = (props) => {
    const {
        text
    } = props;
    return (
        <p>
            {text}
        </p>
    )
}

export default HelpText;